import api from './api.js';

export const reservar_sequencia_pedidos = async () => {
    try {
      const response = await api.post('/Pedidos/reservarSequencia');
  
      if (response.data.sucesso) {
        return response.data.sequencia_reservada;
      } else {
        throw new Error('Falha ao reservar sequência.');
      }
    } catch (error) {
      console.error('Erro ao reservar sequência dos pedidos: ', error.message);
      throw error;
    }
};

export const enviar_ped_ftp = async (nome, conteudo, nome_empresa) => {
    try {
      const response = await api.post('Pedidos/enviarPed',
      {
        nomeArquivo: nome,
        conteudoArquivo: conteudo, 
        nomeEmpresa: nome_empresa
      });

      return response;
    } catch (error) {
      console.error('Erro ao enviar o .PED para o servidor back-end', error.message);
      throw error;
    }
};
  
export const enviar_ped_db = async (pedido_web_capa, pedido_web_itens) => {
    try{
      const response = await api.post('Pedidos/salvarPedidoCompleto', {
        capa: pedido_web_capa,
        itens: pedido_web_itens
      });
  
      return response;
    } catch(error) {
      console.error('Erro ao enviar a capa do .PED para o servidor back-end', error.message);
      throw error;
    }
};
  
export const obter_pedidos = async (cli_codigo, data_formatada, page, pageSize) => {

    try {
      const response = await api.get("Pedidos/obterPedidos", {
      params: {
        cli_codigo,
        data_formatada,
        page,
        pageSize
      }});

      if(response.data.sucesso){
        return response.data;
      }
    } catch (error) {
      console.error('Erro ao obter pedidos: ', error.message);
      throw error;
    }
};

export const obter_pedidos_faturados = async (cli_codigo, data_formatada, page, pageSize) =>  {
  try {
    const response = await api.get("Pedidos/obterPedidosFaturados", {
      params: {
        cli_codigo,
        data_formatada,
        page: page,
        pageSize: pageSize,
      }});
      
      if(response.data.sucesso){
        return response.data;
      }
  } catch (error)
  {
    console.error('Erro ao obter pedidos faturados: ', error.message);
    throw error;
  }
}; 